import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';

import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';

import { SiNextcloud } from 'react-icons/si';
import { SiBookstack } from "react-icons/si";
import { SiHedgedoc } from "react-icons/si";
import { SiBigbluebutton } from "react-icons/si";
import { MdMailLock } from "react-icons/md";
import { MdMail } from "react-icons/md";
import Icon from '@mdi/react';
import { mdiTownHall } from '@mdi/js';

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: '#fff',
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: "rgb(238, 127, 0)",
}));

export default function App() {
  return (
    <Box sx={{ maxWidth: 1000, textAlign: 'center', margin: '0 auto' }}>
      <h1 style={{ borderBottom: 0 }}>ADFC Lübeck Dashboard</h1>
      <h2>Interne Services</h2>
      <Box>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="https://auth.adfc-luebeck.de/realms/adfc/account" target="_blank" rel="noopener noreferrer">
              <Item><ManageAccountsIcon sx={{ fontSize: 72 }}/><br/>SSO Account (Keycloak)</Item>
            </a>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="https://cloud.adfc-luebeck.de" target="_blank" rel="noopener noreferrer">
            <Item><SiNextcloud size={72}/><br/>Cloud (Nextcloud)</Item>
            </a>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="http://wiki.adfc-luebeck.de" target="_blank" rel="noopener noreferrer">
              <Item><SiBookstack size={72}/><br/>Wiki (DokuWiki)</Item>
            </a>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="https://md.adfc-luebeck.de" target="_blank" rel="noopener noreferrer">
              <Item><SiHedgedoc size={72}/><br/>Pad (Hedgedoc)</Item>
            </a>
          </Grid>
        </Grid>
      </Box>
      <h2>Externe Services</h2>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="https://www.premium-webmail.de/roundcube" target="_blank" rel="noopener noreferrer">
              <Item><MdMail size={72}/><br/>Webmail Login</Item>
            </a>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="http://premium-webmail.de/chmail.php" target="_blank" rel="noopener noreferrer">
              <Item><MdMailLock size={72}/><br/>Webmail Passwort ändern</Item>
            </a>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="https://plaudern.chaotikum.org/rooms/l9z-rzf-jvv-suv/join" target="_blank" rel="noopener noreferrer">
              <Item><SiBigbluebutton size={72}/><br/>Telco-Raum beim Chaotikum</Item>
            </a>
          </Grid>
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <a href="https://www.luebeck.de/de/rathaus/politik/pil/index.html" target="_blank" rel="noopener noreferrer">
              <Item><Icon path={mdiTownHall} size={3} /><br/>Politik Informationssystem Lübeck</Item>
            </a>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}